export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('form_label_amzExpenseNo') || '日常请款单编号',
    field: 'amzExpenseNo',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonName') || '业务人员',
    field: 'salesPersonName',
    minWidth: 140,
    align: 'center',
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 100,
    align: 'center',
  },
  {
    title: that.$l('form_label_amzExpenseStatus') || '状态',
    field: 'amzExpenseStatus',
    minWidth: 100,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_oaExpenseProcess') || 'OA申请方式',
    field: 'v_oaExpenseProcess',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_payeeType') || '收款方',
    field: 'v_payeeType',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
  },
  {
    title: that.$l('table_label_payeeCustName') || '收款单位',
    field: 'payeeCustName',
    minWidth: 200,
    align: 'center',
    slots: { default: 'payeeCustName' },
  },
  {
    title: that.$l('table_label_count_currencyAmount') || '费用合计',
    field: 'currencyAmount',
    minWidth: 150,
    align: 'center',
    slots: { default: 'showAmount' },
  },
  {
    title: that.$l('table_label_expensePayerName') || '付款公司',
    field: 'expensePayerName',
    minWidth: 200,
    align: 'center',
  },
  {
    title: that.$l('table_label_paymentMethod') || '付款方式',
    field: 'paymentMethod',
    minWidth: 150,
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: {default: 'createByName'}
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    slots: {default: 'modifyByName'}
  }
]
